import type { DayOffRequest } from '../../../../shared/dpRequests';

export function todayIsoDate(now: Date = new Date()): string {
    return now.toLocaleDateString('sv-SE', { timeZone: 'America/Sao_Paulo' });
}

export function canCancelDayOff(request: Pick<DayOffRequest, 'status' | 'days'>, todayIso: string): boolean {
    if (request.status === 'pending_manager') return true;
    if (request.status !== 'approved') return false;
    const earliest = request.days.map(day => day.date).sort()[0] ?? '';
    return earliest > todayIso;
}
